import { render, staticRenderFns } from "./chizheng.vue?vue&type=template&id=6324ddf3&"
import script from "./chizheng.vue?vue&type=script&lang=js&"
export * from "./chizheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports